module.exports = "img/7.e620c6.webp";